import React, { useState } from 'react';
import ActionButton from '@applied/dragonfruit/src/components/ActionButton/ActionButton';
import IconButton from '@applied/dragonfruit/src/components/IconButton/IconButton';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import Modal from '@applied/dragonfruit/src/components/Modal/Modal';
import { useSnackbar } from '@applied/dragonfruit/src/components/PageSnackbar/snackbar_provider';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import '../../../basic-modal-styles.scss';

type ConfirmationModalProps = {
  onClose: () => void;
  onSubmit: () => Promise<void>;
  viewOnly?: boolean;
};

export function ConfirmationModal(props: ConfirmationModalProps): JSX.Element {
  const { onClose, onSubmit, viewOnly } = props;
  const [isLoading, setIsLoading] = useState(false);
  const snackbar = useSnackbar();

  return (
    <Modal className="confirmation-modal" onClose={onClose}>
      <Flex direction="column" alignment="center" justify="center" gap="md">
        <Flex className="text-container" direction="column" gap="sm">
          <Typography variant="subtitle">Confirm offer letter request</Typography>
          <Typography variant="caption">
            These are the numbers that will appear on your official offer letter, please double
            check your submission!
          </Typography>
        </Flex>
        <ActionButton
          className="confirmation-modal-button"
          appearance="primary"
          loading={isLoading}
          onClick={async () => {
            if (viewOnly) {
              return;
            }

            setIsLoading(true);
            try {
              await onSubmit();
            } catch {
              snackbar.create('Failed to request offer letter, please try again soon.', 'OK');
              setIsLoading(false);
              return;
            }
            onClose();
          }}
          disabled={viewOnly}
        >
          <Typography variant="body">Confirm</Typography>
        </ActionButton>
        <IconButton
          className="close-button"
          icon="CLOSE"
          appearance="default"
          size="small"
          onClick={onClose}
        />
      </Flex>
    </Modal>
  );
}
